import { LanguageModel } from 'models/src/schema/constants'
import { AgentFileUploadSchema } from 'models'

export const MODELS = [
    LanguageModel.gpt5Nano,
    LanguageModel.gpt5Mini,
    LanguageModel.gpt51Instant,
    LanguageModel.gpt51Thinking,
    LanguageModel.gpt52,
    LanguageModel.gpt52Chat,
    LanguageModel.gpt54nano,
    LanguageModel.gpt54mini,
    LanguageModel.gpt54,
    LanguageModel.gpt54Pro,
    LanguageModel.gpt55,
    LanguageModel.gpt55Pro,
    LanguageModel.gemini25FlashLite,
    LanguageModel.gemini25Flash,
    LanguageModel.gemini25Pro,
    LanguageModel.gemini3Flash,
    LanguageModel.gemini3ProPreview,
    LanguageModel.gemini31FlashLitePreview,
    LanguageModel.gemini31ProPreview,
    LanguageModel.gemini31FlashLite,
    LanguageModel.gemini35Flash,
    LanguageModel.claudeHaiku45,
    LanguageModel.claudeSonnet46,
    LanguageModel.claudeSonnet5,
    LanguageModel.claudeOpus46,
    LanguageModel.claudeOpus47,
    LanguageModel.claudeOpus48,
    LanguageModel.claudeFable5,
    LanguageModel.deepseek32,
    LanguageModel.deepseek4pro,
    LanguageModel.deepseek4Flash,
    LanguageModel.alibabaQwen36Plus,
    LanguageModel.alibabaQwen37Max,
    LanguageModel.alibabaQwen37Plus,
    LanguageModel.xaiGrok43,
    LanguageModel.zaiGlm52,
    LanguageModel.zaiGlm52Fast,
] as const

export const DEFAULT_TEMPERATURE = 0.6
export const DEFAULT_PROMPT = ''
export const DEFAULT_LIMIT = 5
export const FILE_UPLOAD_DEFAULTS = AgentFileUploadSchema.parse({})
